import type { Permission } from './api';

/** Spanish label per `resource` of `PERMISSION_CATALOG` (`apps/api` `permission-catalog.ts`). */
export const RESOURCE_LABELS: Record<string, string> = {
  user: 'Usuarios',
  role: 'Roles',
  customer: 'Empresas cliente',
  site: 'Sedes',
  contract: 'Contratos',
  menu: 'Menús',
  order: 'Pedidos',
  production: 'Producción',
  deliverynote: 'Remitos',
  route: 'Hojas de ruta',
  delivery: 'Entregas',
  invoice: 'Comprobantes',
  creditnote: 'Notas de crédito y débito',
  payment: 'Pagos',
  fiscal: 'Configuración fiscal',
  dashboard: 'Dashboard',
  report: 'Reportes',
  notification: 'Notificaciones',
  settings: 'Parámetros del sistema',
  audit: 'Auditoría',
};

export interface PermissionGroup {
  resource: string;
  label: string;
  permissions: Permission[];
}

/**
 * Groups `permissions` by `resource`, in the order each resource first
 * appears — the same order `PERMISSION_CATALOG` already declares them in,
 * never recomputed or alphabetised (design.md §9.5).
 */
export function groupPermissionsByResource(permissions: readonly Permission[]): PermissionGroup[] {
  const groups: PermissionGroup[] = [];
  const byResource = new Map<string, PermissionGroup>();

  for (const permission of permissions) {
    let group = byResource.get(permission.resource);

    if (group === undefined) {
      group = {
        resource: permission.resource,
        label: RESOURCE_LABELS[permission.resource] ?? permission.resource,
        permissions: [],
      };
      byResource.set(permission.resource, group);
      groups.push(group);
    }

    group.permissions.push(permission);
  }

  return groups;
}
